import styled from '@emotion/styled';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { logException } from '../../../common/sentry';
import { t } from '../../../localization/LocaleContext';

const BackgroundContainer = styled.div`
  min-height: ${({ theme }) =>
    `calc(100vh - ${theme.elements.topBarMobileHeight})`};
  background-color: ${({ theme }) => theme.colors.blueDark100};
  z-index: 0;
  position: relative;
  overflow: hidden;
  top: 0;
  width: 100vw;

  ${({ theme }) => theme.mediaQuery.md} {
    min-height: ${({ theme }) =>
      `calc(100vh - ${theme.elements.topBarDesktopHeight})`};
    width: calc(100vw - var(--sidebar-width));
  }
`;

const TextContainer = styled.div`
  color: ${({ theme }) => theme.colors.blueDark10};
  padding-top: ${({ theme }) => theme.spacers.l};
  padding-right: ${({ theme }) => theme.spacers.s};
  padding-bottom: 0px;
  padding-left: ${({ theme }) => theme.spacers.s};

  ${({ theme }) => theme.mediaQuery.sm} {
    padding-left: ${({ theme }) => theme.spacers.xxl};
    padding-top: 200px;
  }
`;

const Heading = styled.h2`
  ${({ theme }) => theme.textStyles.scoreS};
  color: ${({ theme }) => theme.colors.monochrome10};
  padding: 0;
  margin: 0;
`;

const ParagraphContainer = styled.section`
  ${({ theme }) => theme.textStyles.paragraphM};
  color: ${({ theme }) => theme.colors.monochrome10};
  margin: ${({ theme: { spacers } }) => `${spacers.m} 0 ${spacers.l}`};
  max-width: 420px;
`;

export default function PageNotFound() {
  const { pathname } = useLocation();

  useEffect(() => {
    logException(new Error(`Page not found at path: ${pathname}`), {
      path: pathname,
    });
  }, [pathname]);

  return (
    <BackgroundContainer>
      <TextContainer>
        <Heading>{t('page_not_found_title')}</Heading>

        <ParagraphContainer>
          <p>{t('page_not_found_body')}</p>
        </ParagraphContainer>
      </TextContainer>
    </BackgroundContainer>
  );
}
